/** @type {"bottom"} */
export const BOTTOM = "bottom";
/** @type {"height"} */
export const HEIGHT = "height";
/** @type {"left"} */
export const LEFT = "left";
/** @type {"right"} */
export const RIGHT = "right";
/** @type {"top"} */
export const TOP = "top";
/** @type {"width"} */
export const WIDTH = "width";
/** @type {"x"} */
export const X = "x";
/** @type {"y"} */
export const Y = "y";

export const BOUNDING_RECT_KEYS = [
  BOTTOM,
  HEIGHT,
  LEFT,
  RIGHT,
  TOP,
  WIDTH,
  X,
  Y,
];
